import rehypeRaw from 'rehype-raw';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import type { HtmlMarkdownContentProps } from './types';

import styles from './styles.module.scss';

function normalizeNonBreakingSpaces(value: string): string {
  return value.replace(/&nbsp;|&#160;|\u00a0/gi, ' ');
}

export function HtmlMarkdownContent({
  content,
  className,
}: HtmlMarkdownContentProps): React.ReactElement | null {
  const trimmed = content.trim();
  if (!trimmed) {
    return null;
  }
  const normalizedContent = normalizeNonBreakingSpaces(trimmed);

  const rootClassName = [styles.root, 'ql-editor', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName}>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{normalizedContent}</ReactMarkdown>
    </div>
  );
}
